/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/marker': {
    width: 14,
    height: 17,
    viewBox: '0 0 14 17',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.415 2.585a6.243 6.243 0 10-8.83 8.83l4.022 4.02c.217.218.57.218.786 0l4.022-4.02a6.243 6.243 0 000-8.83zM2.05 2.05a7 7 0 119.9 9.9l-4.021 4.02a1.313 1.313 0 01-1.858 0l-4.02-4.02a7 7 0 010-9.9z" _fill="#E25046"/><path pid="1" d="M10.973 7a3.973 3.973 0 11-7.946 0 3.973 3.973 0 017.946 0z" _fill="#E25046"/>'
  }
})
